import React, { useEffect, useState } from "react";
import { Card, Skeleton } from "antd";
import Utils from "../../../../utils/Utils";
import { getFreeGuidesApi } from "../../../../api/candidate";
import WebUtils from "../../../../utils/WebUtils";
import FreeGuidesCardData from "./FreeGuidesCardData";
import FGNoData from "./FGNoData";

const userDetail = Utils.getUserDetail();
const pageSize = 6;

function FreeGuidesDisplay({
  guideDataFlag,
  setGuideDataFlag,
  jobGuideFilters,
  searchButtonText,
  clearResultsFlag,
  notFoundFlag,
  setNotFoundFlag,
  selectedIndustry,
  setSelectedIndustry,
}) {
  const [loading, setLoading] = useState(false);
  const [currPage, setCurrPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);

  const getJobGuides = (pageNo, pageSize, searchInput) => {
    const url = `${getFreeGuidesApi}?industryId=${selectedIndustry?.industryId}&jobGuideFilters=${jobGuideFilters}&pageNumber=${pageNo}&pageSize=${pageSize}&searchValue=${searchInput}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          let count = result.data.data.totalCount;
          if (count === 0) {
            setNotFoundFlag(true);
          } else {
            setNotFoundFlag(false);
          }
          setGuideDataFlag(result.data.data.jobGuideResponseData);
          // setGuideDataFlag([]);
          setPageCount(count);
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "not_found"
        ) {
          setNotFoundFlag(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (selectedIndustry) {
      setCurrPage(0);
      getJobGuides(0, pageSize, searchButtonText);
    }
  }, [jobGuideFilters, searchButtonText, selectedIndustry]);

  const onPageChange = (num) => {
    setCurrPage(num - 1);
    getJobGuides(num - 1, pageSize, searchButtonText);
  };

  return (
    <>
      {loading ? (
        <>
          <div className="mt-4 flex flex-col items-center">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-[1.1rem] gap-x-[1.3rem] w-full">
              <Card className="w-full ">
                <Skeleton active paragraph />
              </Card>
              <Card className="w-full ">
                <Skeleton active paragraph />
              </Card>
              <Card className="w-full ">
                <Skeleton active paragraph />
              </Card>
              <Card className="w-full ">
                <Skeleton active paragraph />
              </Card>
              <Card className="w-full ">
                <Skeleton active paragraph />
              </Card>
              <Card className="w-full ">
                <Skeleton active paragraph />
              </Card>
            </div>
          </div>
        </>
      ) : notFoundFlag || (guideDataFlag && guideDataFlag.length > 0) ? (
        <FreeGuidesCardData
          notFoundFlag={notFoundFlag}
          guideDataFlag={guideDataFlag}
          pageNumber={currPage}
          pageSize={pageSize}
          onPageChange={onPageChange}
          pageCount={pageCount}
          searchButtonText={searchButtonText}
        />
      ) : (
        !notFoundFlag &&
        (!guideDataFlag || guideDataFlag.length === 0) && (
          <div className="mt-8 py-2">
            <FGNoData text="No free guides are available at the moment. More will be added in the future." />
          </div>
        )
      )}
    </>
  );
}

export default FreeGuidesDisplay;
